import React from "react";
import { Sparkles, Loader2 } from "lucide-react";

export const FIELD_LABELS = {
  name: "Name *", phone: "Phone *", email: "Email", source: "Source", project_name: "Project name", budget_min: "Budget min",
  budget_max: "Budget max", configuration: "Configuration", location_pref: "Location", notes: "Notes", created_at: "Created date",
  updated_at: "Updated date", owner: "Lead owner", status: "Lead status", followup_date: "Follow-up date", due_date: "Due date",
};

const fieldOf = (map, i) => Object.keys(map).find((k) => map[k] === String(i)) || "";

// Live CSV preview: every file column shows its sample values and a picker for the Propzel field it feeds.
export const ColumnMapper = ({ headers, rows, map, setMap, reasons, aiState }) => {
  const assign = (i, field) => {
    const next = { ...map };
    Object.keys(next).forEach((k) => { if (next[k] === String(i)) next[k] = ""; });
    if (field) next[field] = String(i);
    setMap(next);
  };
  const sample = rows.slice(0, 6);
  return (
    <div data-testid="import-mapper" className="border border-[#E6E4DD] bg-white rounded-sm min-w-0">
      <div className="px-4 py-3 border-b border-[#E6E4DD] flex flex-wrap items-center justify-between gap-2">
        <div className="label-caps">Live file preview · pick the Propzel field for each column</div>
        <div data-testid="import-ai-status" className="text-[11px] text-forest/60 inline-flex items-center gap-1.5">
          {aiState === "loading" ? <><Loader2 className="h-3.5 w-3.5 animate-spin" /> AI is reading your columns…</>
            : aiState === "ai" ? <><Sparkles className="h-3.5 w-3.5 text-clay" /> Columns matched by AI — check and adjust</>
              : aiState === "rules" ? "Matched by header names — check and adjust" : null}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="text-xs border-collapse">
          <thead>
            <tr>
              {headers.map((h, i) => {
                const f = fieldOf(map, i);
                return (
                  <th key={i} className={`align-top text-left px-2 py-2 border-b border-r border-[#E6E4DD] min-w-[150px] ${f ? "bg-[#2D6A4F]/5" : "bg-bone-alt/40"}`}>
                    <select data-testid={`import-col-${i}`} value={f} onChange={(e) => assign(i, e.target.value)} title={reasons[f] || ""}
                      className={`w-full h-8 border rounded-sm px-1.5 text-xs bg-white ${f ? "border-[#2D6A4F] text-[#2D6A4F] font-semibold" : "border-[#E6E4DD] text-forest/50"}`}>
                      <option value="">Skip column</option>
                      {Object.entries(FIELD_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                    </select>
                    <div className="mt-1.5 text-[10px] uppercase tracking-[0.12em] text-forest/50 font-bold truncate max-w-[180px]">{h || `Column ${i + 1}`}</div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {sample.map((r, ri) => (
              <tr key={ri}>{headers.map((_, i) => <td key={i} className="px-2 py-1.5 border-b border-r border-[#E6E4DD] text-forest/70 truncate max-w-[200px]">{r[i] || <span className="text-forest/25">—</span>}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>
      {(map.name === "" || map.phone === "") && <div data-testid="import-required-hint" className="px-4 py-2 text-xs text-clay border-t border-[#E6E4DD]">Pick the columns for Name and Phone to continue.</div>}
    </div>
  );
};
